
import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText } from '@wordpress/block-editor';
import './editor.scss';

export default function Edit(props) {

	const blockProps = useBlockProps({
		className: 'c4l-example'
	});

	const { attributes, setAttributes } = props;
	const { title, text } = attributes;

	return (
		<div {...blockProps}>
			<div className='c4l-example-content'>
				<RichText
					tagName='h1'
					className='c4l-example-title'
					value={title}
					onChange={(newVal) => setAttributes({ title: newVal })}
					placeholder={__("Example title here", 'example')}
				/>
				<RichText
					tagName='div'
					className='c4l-example-text'
					multiline='p'
					value={text}
					onChange={(newVal) => setAttributes({ text: newVal })}
					placeholder={__("Type the Example text here", 'example')}
				/>
			</div>
		</div>
	);
}
